import gql from "graphql-tag";

export const GetSubscriptionDetails = gql`
  query GetSubscriptionDetails {
    accounts {
      type
      fixedFee
      variableFee
      balance
      invoices {
        invoiceUrl
        amount
        paidAt
      }
      subscription {
        subscriptionPlan {
          id
          amount
          nickname
          transactionVolumeLimit
          videoLimit
          opportunityLimit
          fixedFee
          variableFee
        }
        status
        currentPeriodEnd
      }
      paymentMethods {
        type
        last4
        isDefault
      }
      subscriptionPlans {
        id
        nickname
        amount
        videoLimit
        opportunityLimit
        transactionVolumeLimit
        stripePlanId
      }
      usageStats {
        videoCount
        opportunityCount
        transactionVolumeAmount
      }
    }
  }
`;
